import { render } from "./deleteDevis.vue?vue&type=template&id=2cea82b6&scoped=true"
import script from "./deleteDevis.vue?vue&type=script&lang=js"
export * from "./deleteDevis.vue?vue&type=script&lang=js"

import "./deleteDevis.vue?vue&type=style&index=0&id=2cea82b6&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cea82b6"]])

export default __exports__